import React, { useEffect } from 'react';
import { useIntl } from 'react-intl';
import CustomSelect from 'utils/components/CustomSelect';
import { PLACEHOLDER_MESSAGES_STEP1 } from '../../constants';
import { useFormikContext } from 'formik';
import segmentsQuery from './query';
import { Query } from 'react-apollo';
import { useStateMachine } from 'little-state-machine';

const SegmentSelect = ({ name, updateField }) => {
  const intl = useIntl();
  const { values: { segment, sector } } = useFormikContext();
  const { state } = useStateMachine();

  // /* Reset segment when sector changes */
  useEffect(() => {
    if (sector && !state.isEditProject) updateField(name, "");
  }, [sector]);

  return (
    <Query 
      query={segmentsQuery}
      variables={{ market: sector }}
    >
      {({ loading, data, error }) => {
        const segmentsList =
          data?.sectors?.edges?.map(({ node }) => ({
            id: node.id,
            value: node.id,
            label: intl.locale === "es" ? node.name : node.nameEn,
          })) || [];

        if (error) {
          const { graphQLErrors, networkError } = error;
          if (graphQLErrors || networkError) {
            console.error("Error fetching products GraphQL:", graphQLErrors);
            console.error("Error fetching products Network:", networkError);
          }
        }

        return (
          <CustomSelect
            config={{
              name,
              initialValue: segment && segmentsList?.find(({ id }) => id === segment)?.label,
              placeholderMessage: intl.formatMessage(
                PLACEHOLDER_MESSAGES_STEP1["segment"]
              ),
              disabled: !sector && !segment,
              disabledPlaceholder: intl.formatMessage({
                id: "ProjectStepForm.segments.firstSelectSector",
              }),
            }}
            selectValues={segmentsList}
            updateField={updateField}
            returnValue="id"
          />
        );
      }}
    </Query>
  );
}

export default SegmentSelect;